function CSHotspots(){

    var self = this;

    self.numberOfStories = $(".block").length;

    console.log(this.numberOfStories);

    self.stories = [];

    for (var i=0; i < self.numberOfStories; i ++){

        var h = new CSHotspot(i, "#p", 800);

        self.stories.push(h);

    }

}



